export default __webpack_public_path__ + "73d235eeb8900ff81633f3364cb022a1.png";